module.exports = __webpack_public_path__ + "SP_NarratorVideo_1-9158ed5592cb16f45dc921cb1c5320c3.png";